import { Component } from '@angular/core'
import { MbProductDataImagesTabConnector } from '../../../connectors/product-data-images'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { CurrentProductService } from '@spartacus/storefront'
import { PdpGalleryService } from '../../../../shared/services/pdp-gallery.service'
import { isNotNullable } from '@spartacus/core'
import { MbDataImageFigureEntry, MbImageDatasetEntry } from '../../../../models'
import { MbModalService } from '../../../../shared/services/modal.service'

@Component({
  selector: 'mb-pdp-product-data-images-tab',
  templateUrl: './pdp-product-data-image-tab.component.html',
  styleUrls: ['./pdp-product-data-image-tab.component.scss']
})
export class PdpProductDataImageTabComponent {

  productName: string = ''
  product$ = this.currentProductService.getProduct().pipe()
  imageFigures$ = this.product$.pipe(
    filter(isNotNullable),
    tap(product => this.productName = product?.nameHtml || ''),
    map(product => product?.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.productDataImagesConnector.get(productCode))
  )

  constructor (private currentProductService: CurrentProductService,
              private productDataImagesConnector: MbProductDataImagesTabConnector,
              private modalService: MbModalService,
              private pdpGalleryService: PdpGalleryService) {
  }

  async openDialog (activeImage: MbImageDatasetEntry, images: MbImageDatasetEntry[], description: string) {
    try {
      await this.pdpGalleryService.openGalleryDialog({
        activeImage: this.pdpGalleryService.toActiveImageData(activeImage, description),
        gallery: this.pdpGalleryService.toGalleryImageData(images, description),
        hasApplicationData: true,
        productName: this.productName,
        headline: activeImage.headline
      })
    } catch (_) {
    }
  }

  sortBySortOrder (dataImageFigures: MbDataImageFigureEntry[]) {
    return dataImageFigures?.sort((a, b) => a.sortOrder && b.sortOrder && a.sortOrder - b.sortOrder || 0)
  }
}
